import React, { useState, useEffect, useContext } from 'react';
import { UserContext } from '../../../Context/UserContextProvider';
import axios from "../../../../axios/index"
import { Link } from 'react-router-dom';
import { useLocation, useHistory } from 'react-router-dom';

import ShowProfileModal from '../../DashboardFileManagement/CardDetail/ShowProfileModal';
import DashboardHeader from '../../DashboardReuseAbleComponents/DashboardHeader';
import DashboardSideMenu from '../../DashboardReuseAbleComponents/DashboardSideMenu';
import { Form } from 'react-bootstrap';
import { sendMessageValidate } from './sendMessageValidate';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Styles
import styles from "./../StaffManagment.module.css";
import Dstyles from "../../Profile/MyAccount.module.css"

// Images
import arrowIcon from "./../../../../assets/img/DashboardICons/ArrowRounded.svg";

const StaffSupportMessageDetail = () => {
    const { userToken } = useContext(UserContext);
    const { state } = useLocation();
    const history = useHistory()
    const [errors, setErrors] = useState({})
    const [btnLoader, setBtnLoader] = useState(false)
    // console.log(state)
    const [modalShow, setModalShow] = useState(false);

    const [formStaffMessage, setFormStaffMessage] = useState({
        id: "",
        fileID: "",
        messageText: "",
    })

    const formStaffMessageChangeHandler = (e) => {
        setFormStaffMessage({
            ...formStaffMessage,
            [e.target.name]: e.target.value
        })
    }

    useEffect(() => {
        const setValidate = async () => {
            await setErrors(sendMessageValidate(formStaffMessage))
            // console.log(errors)
        }
        setValidate()
    }, [formStaffMessage])

    return (
        <>

            <ShowProfileModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />

            <ToastContainer
                position="top-right"
                autoClose={8000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            <div className='container-fluid'>
                <div className='row'>
                    <div className="col-md-9" >
                        <div className={`my-3 pb-4 px-0 ${styles.file_cards_container}`}>
                            <DashboardHeader onClick={() => setModalShow(true)} class="px-0" />

                            <div
                                className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2"
                                dir="rtl"
                            >
                                <div className='d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2'>
                                    <a href='#' onClick={history.goBack}> <img className='ms-2' src={arrowIcon} alt="icon" /></a>
                                    <div className={styles.text1}>
                                        {state.name + " " + state.family}
                                    </div>
                                </div>
                            </div>

                            {/* Total Staff Support Detail */}

                            <div dir="rtl" className="mt-4 mx-4 pt-2 px-2">
                                <div className="text-right">
                                    <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="fileID"> کد فایل </Form.Label>
                                        <Form.Control
                                            className={`${styles.form_control_input} shadow-none`}
                                            type="text"
                                            id="fileID"
                                            name="fileID"
                                            placeholder="کد فایل مربوطه را وارد کنید"
                                            value={formStaffMessage.fileID}
                                            onChange={formStaffMessageChangeHandler}
                                        />
                                    </Form.Group>
                                    <Form.Group className={`${styles.total_form_group} mb-4 pb-4 d-flex flex-column w-100`}>
                                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="messageText"> متن پیام </Form.Label>
                                        <Form.Control
                                            style={{ resize: "none" }}
                                            className={`${styles.form_control_input} shadow-none`}
                                            as="textarea"
                                            rows={12}
                                            id="messageText"
                                            name="messageText"
                                            value={formStaffMessage.messageText}
                                            onChange={formStaffMessageChangeHandler}
                                        />
                                    </Form.Group>

                                    <div className="d-flex justify-content-end align-items-center mt-5 mb-2">
                                        {btnLoader ? (
                                            <div className={Dstyles.btn_loader_container}>
                                                <div className={Dstyles.btn_spinner}></div>
                                            </div>
                                        )
                                            : (
                                                <div className={`${styles.total_save_btn} text-center d-flex justify-content-center align-items-center me-3`} role="button" onClick={submitHandler}>
                                                    <button className={`border-0 bg-transparent text-white`}>ارسال</button>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className='col-md-3'>
                        {/* sideMenu starts */}
                        <DashboardSideMenu managePersonal manageSupportStaff />
                        {/* sideMenu ends */}
                    </div>
                </div>
            </div>
        </>
    )

    function submitHandler() {
        if (!Object.keys(errors).length) {
            notify("درحال ارسال پیام", "success")
        } else {
            notify("!لطفا تمام فیلد هارا پرکنید", "error")
        }
    }

    function notify(text, type) {
        if (type === "success") {
            toast.success(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            formSendHandler()
        } else if (type === "sentsuccess") {
            toast.success(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            // setBtnLoader(false)
        }
        else {
            toast.error(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            // console.log(errors)
            setBtnLoader(false)
        }
    };

    async function formSendHandler() {
        try {
            notify("درحال ارسال پیام", "sentsuccess")
            setBtnLoader(true)
            var data = new FormData();
            data.append('ReceiverUserId', state.userId);
            data.append('EstateCode', formStaffMessage.fileID);
            data.append('TicketBody', formStaffMessage.messageText);

            const apiData = await axios.post(
                "Ticket",
                data,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            setBtnLoader(false)
            notify("پیام با موفقیقت ارسال شد", "sentsuccess")
            history.push("/staff-managment-support")
        } catch (error) {
            notify("خطای سرور", "error")
        }

    }
}

export default StaffSupportMessageDetail;
